import React, { useState, useEffect } from "react";

import Popup from "reactjs-popup";
import { Link } from "react-router-dom";
import moment from "moment";

import { saveOffer } from "services/offer_service";

function App({
  id,
  title,
  subTitle,
  division = "",
  createdDate,
  savedOfferId,
  removeSaveOffer,
  changeOffers = null,
}) {
  // get the teams in the backend;
  const [diffDays, setDiffDays] = useState(-1);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setSaved(savedOfferId ? true : false);

    if (createdDate) {
      let currentDate = moment();
      let createdDateMoment = moment(createdDate);
      setDiffDays(currentDate.diff(createdDateMoment, "days"));
    }
  }, []);

  const saveOfferFn = async () => {
    await saveOffer(id);
    setSaved(true);
    if (changeOffers) {
      await changeOffers();
    }
    return;
  };

  const deleteOfferFn = async () => {
    await removeSaveOffer(savedOfferId);
    setSaved(false);

    if (changeOffers) {
      await changeOffers();
    }
    return;
  };

  return (
    <div className="box teamCard" to={`/ofertas/${id}`}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p
          style={{ height: "20px", overflowY: "hidden" }}
          className="label header bold"
        >
          {title}
        </p>
        <Popup
          trigger={<i className="fa fa-ellipsis-v"></i>}
          position="left center"
        >
          <div className="dropdown-content">
            <div className="dropdown-item">
              {saved ? (
                <div onClick={() => deleteOfferFn(id)}>
                  Retirar Vaga&nbsp;&nbsp;
                  <i className="fas fa-times-circle"></i>{" "}
                </div>
              ) : (
                <div onClick={() => saveOfferFn(id)}>
                  Guardar Vaga &nbsp;&nbsp;<i className="fas fa-save"></i>
                </div>
              )}
            </div>
            <Link className="dropdown-item" to={`/ofertas/${id}`}>
              Detalhe da vaga
            </Link>
          </div>
        </Popup>
      </div>
      <p style={{ height: "20px", overflowY: "hidden" }} className="label">
        {subTitle}
      </p>
      <p
        style={{ height: "20px", overflowY: "hidden", color: "#D2D0D0" }}
        className="label"
      >
        {division}
      </p>
      <br></br>
      <p style={{ fontSize: "12px", color: "#D2D0D0" }} className="label">
        Publicado há {diffDays} dia(s)
      </p>
    </div>
  );
}

export default App;
